var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bld-adm-edit"},[_c('div',{staticClass:"title wi8_font"},[_vm._v("Admin Edit Article Builder")]),_c('div',{staticClass:"content"},[_c('AdmEdit')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }